import type { Verdict } from '../../../lib/menu-judge';

/**
 * 3상태 선택 — 상속 · 허용 · 차단 (확정 시안 v4 · 정본 제안 G1).
 *
 * 정본의 Switch(B7)는 켬/끔 둘뿐이라 「위에서 물려받음」을 담지 못한다 — 그래서 따로 둔다.
 * 누르면 바로 저장된다(설정 화면 규칙: 목록을 고치는 탭은 저장바 없이 고른 순간 반영).
 *
 * ★ 회사 끔 · 모듈 끔인 메뉴는 「허용」을 잠근다 — 눌러도 열리지 않는 단추는 두지 않는다.
 *   이미 허용이 걸려 있으면 잠그지 않고 그대로 보인다(「적용 안 됨」 태그가 곁에 선다).
 */
interface Props {
  value: Verdict;
  onChange: (next: Verdict) => void;
  /** 그룹 이름 — 「메일 — 인사팀」. */
  label: string;
  /** 첫 칸 이름 — 부서별 = 「상속」, 개인별 = 「부서 기준」. */
  noneLabel?: string;
  /** 허용을 잠그는 이유(있으면 잠근다). */
  allowLockedReason?: string | null;
  disabled?: boolean;
}

const OPTIONS: Array<{ v: Verdict; text: string }> = [
  { v: 'none', text: '상속' },
  { v: 'allow', text: '허용' },
  { v: 'deny', text: '차단' },
];

export function TriState({ value, onChange, label, noneLabel = '상속', allowLockedReason = null, disabled = false }: Props) {
  return (
    <span className={`mpx-tri${disabled ? ' is-disabled' : ''}`} role="radiogroup" aria-label={label}>
      {OPTIONS.map(({ v, text }) => {
        const locked = v === 'allow' && !!allowLockedReason && value !== 'allow';
        return (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={value === v}
            className={`mpx-tri__opt mpx-tri__opt--${v}`}
            disabled={disabled || locked}
            title={locked ? allowLockedReason ?? undefined : undefined}
            onClick={() => { if (value !== v) onChange(v); }}
          >
            {v === 'none' ? noneLabel : text}
          </button>
        );
      })}
    </span>
  );
}
